// CU-86d45b372 — the customer-facing self-profile over the same PUT /user contract as /profile; billing (CU-86d45b38j)
// sits below it over finance's subject-bound customer contract, never the generic caller-selected one.
import React, { useState } from "react";
import { getSessionUser } from "../../utils/auth/sessionUser";
import { EditOutlined, SaveOutlined } from "@ant-design/icons";

import CustomerLayout from "../../components/customer/CustomerLayout";
import { PageContainer } from "../../components/shared";
import { useNotifications } from "../../context/NotificationContext";
import { updateProfile } from "../../api/admin/userApi";
import type { User } from "../../types/admin/UserTypes";
import { toSelfProfilePayload } from "../../utils/profile/selfProfileName";
import SelfProfileBasicInfoSections from "../profile/sections/SelfProfileBasicInfoSections";
import CustomerProfileBilling from "./CustomerProfileBilling";

const readCookieUser = (): User => {
	try {
		return getSessionUser();
	} catch {
		return {} as User;
	}
};

const CustomerProfilePage: React.FC = () => {
	const { showSuccess, showError } = useNotifications();
	const [userData, setUserData] = useState<User>(readCookieUser);
	const [isEditing, setIsEditing] = useState(false);

	const handleSave = async () => {
		try {
			await updateProfile(toSelfProfilePayload(userData));
		} catch (err) {
			console.error("Save error (customer profile):", err);
			showError("Failed to update profile");
			return;
		}

		showSuccess("Profile updated successfully");
		setIsEditing(false);
	};

	const actions = isEditing
		? [{ label: "Save", icon: <SaveOutlined />, onClick: () => handleSave(), type: "primary" as const }]
		: [{ label: "Edit Profile", icon: <EditOutlined />, onClick: () => setIsEditing(true), type: "primary" as const }];

	return (
		<CustomerLayout>
			<PageContainer title="Profile" subtitle="Your account details" maxWidth={1280} actions={actions} data-testid="customer-profile-page">
				<SelfProfileBasicInfoSections user={userData} isEditing={isEditing} setUserData={setUserData} />
				<CustomerProfileBilling />
			</PageContainer>
		</CustomerLayout>
	);
};

export default CustomerProfilePage;
